<div class="header-wrapper">
    <div class="project-info-wrapper">
        <div class="image-wrapper">
            <img
                id="motoric-project-icon"
                src="assets/svg/project-split-screen/header/motoric-icon.svg"
                alt="motoric"
                *ngIf="
                    container.containerType === ContainerType.PROJECT_MOTORIC
                "
            />
            <img
                id="visual-project-icon"
                src="assets/svg/project-split-screen/header/visual-icon.svg"
                alt="visual"
                *ngIf="container.containerType === ContainerType.PROJECT_VISUAL"
            />
        </div>
        <div class="project-name-wrapper">
            <span>{{ container.name }}</span>
        </div>
    </div>
    <div class="project-settings-wrapper" *ngIf="isOwner">
        <div
            [title]="
                'projectSplitScreen.components.header.membersHover' | translate
            "
            class="button project-members-button"
            (click)="openMembers()"
            (mouseenter)="hoverFunctionalButtonIdx = 0"
            (mouseleave)="hoverFunctionalButtonIdx = null"
        >
            <img
                id="members-icon"
                [src]="
                    'assets/svg/reusable-svg/members' +
                    (hoverFunctionalButtonIdx === 0 ? '-hover' : '') +
                    '.svg'
                "
                alt="member"
            />
            <div
                class="tryb-notification-icon-wrapper"
                *ngIf="areRequestsExisting()"
            >
                <img
                    class="notification-icon"
                    src="assets/svg/reusable-svg/notification.svg"
                    alt="notification-icon"
                />
            </div>
        </div>
        <div
            [title]="
                'projectSplitScreen.components.header.settingsHover' | translate
            "
            class="button project-settings-button"
            (click)="openSettings()"
            (mouseenter)="hoverFunctionalButtonIdx = 1"
            (mouseleave)="hoverFunctionalButtonIdx = null"
        >
            <img
                id="settings-icon"
                [src]="
                    'assets/svg/reusable-svg/settings' +
                    (hoverFunctionalButtonIdx === 1 ? '-hover' : '') +
                    '.svg'
                "
                alt="settings"
            />
        </div>
    </div>
</div>
